import React, { useEffect } from 'react';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import PageContainer from '../../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { useParams } from 'react-router';

import EventSecitonFiled from '@jumbo/Dashboards/Events/EventSectionFields';
import { useSelector, useDispatch } from 'react-redux';
import EventsRequests from 'services/events';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.eventsPage'} />, link: '/events' },
  { label: <IntlMessages id={'pages.EventSectionsPage'} />, isActive: true },
];

const EventSections = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { eventSecitons } = useSelector(({ events }) => events);

  useEffect(() => {
    if (id) {
      dispatch(EventsRequests.getEventSectionsById(id));
    }
  }, [id]);

  return (
    <PageContainer heading={<IntlMessages id="pages.EventSectionsPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <EventSecitonFiled eventID={id} />
            {eventSecitons && eventSecitons.length !== 0
              ? eventSecitons.map(section => {
                  return <EventSecitonFiled eventID={id} id={section._id} key={section._id} />;
                })
              : null}
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default EventSections;
